var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.sepa_core_collection") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            {
              staticClass: "min-w-100 justify-content-start align-items-center",
            },
            [
              _c(
                "b-col",
                {
                  staticClass: "d-flex justify-content-start mt-3 mb-5",
                  attrs: { cols: "12" },
                },
                [
                  _c("back-button", {
                    staticClass: "btnFilter_2 mr-2 btn-back",
                    attrs: {
                      returnUrl: _vm.returnUrl,
                      menuLink: "/mandatpage/unit",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c("b-col", { staticClass: "mt-3", attrs: { cols: "12" } }, [
                _c(
                  "div",
                  [
                    _c(
                      "form-accordion",
                      {
                        attrs: {
                          title: _vm.$t("mandate.mandate_info"),
                          isTitleUpperCase: false,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-top": "1.5rem",
                              "padding-bottom": "1.5rem",
                            },
                          },
                          [
                            _c(
                              "b-row",
                              { staticClass: "ml-0 mr-5 form-group" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { sm: "5" } },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputLabel: _vm.$t(
                                          "mandate.unique_mandate_rf"
                                        ),
                                        inputValue: _vm.UMR,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "form-accordion",
                      {
                        attrs: {
                          title: _vm.$t("mandate.cdtr_info"),
                          isTitleUpperCase: false,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-top": "1.5rem",
                              "padding-bottom": "1.5rem",
                            },
                          },
                          [
                            _c(
                              "b-row",
                              { staticClass: "ml-0 mr-5 form-group" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { sm: "5" } },
                                  [
                                    _c("iban-input", {
                                      attrs: {
                                        label: _vm.$t("mandate.cdtr_iban"),
                                        required: true,
                                        hint: _vm.$t("mandate.iban_hint") || "",
                                      },
                                      model: {
                                        value: _vm.IbanSelected,
                                        callback: function ($$v) {
                                          _vm.IbanSelected = $$v
                                        },
                                        expression: "IbanSelected",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "form-accordion",
                      {
                        attrs: {
                          title: _vm.$t("mandate.details_transactions"),
                          isTitleUpperCase: false,
                        },
                      },
                      [
                        _c(
                          "b-row",
                          {
                            staticClass: "ml-0 mt-4 mb-4 mr-5 mr-5 form-group",
                          },
                          [
                            _c(
                              "b-col",
                              { attrs: { sm: "5" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t("mandate.amt") + " (€)",
                                    placeholderValue:
                                      _vm.$t("mandate.amt") + " (€)",
                                    isMandatory: "",
                                    inputType: "number",
                                  },
                                  model: {
                                    value: _vm.Amount,
                                    callback: function ($$v) {
                                      _vm.Amount = $$v
                                    },
                                    expression: "Amount",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("b-col", { attrs: { sm: "5" } }, [
                              _c(
                                "div",
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "filter-item-title d-block mb-1",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("mandate.date_due")) + " "
                                      ),
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [_vm._v("*")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("datetime-picker-custom", {
                                    staticClass: "mr-3",
                                    class: {
                                      "filter-item-input": true,
                                      "filter-item-input-complete": _vm.DueDate,
                                    },
                                    staticStyle: { padding: "0.35rem" },
                                    attrs: {
                                      showTime: false,
                                      format: "YYYY-MM-DD",
                                      periodFull: "",
                                      id: "filter-datebegin",
                                      customInputParentClass:
                                        "filter-item-content",
                                      customInputClass: "w-100",
                                      maxLength: 19,
                                      placeholderValue: _vm.$t(
                                        "common.datepicker_format_date3"
                                      ),
                                      inputIcon: "fa-solid fa-calendar",
                                      disablePastDates: "",
                                    },
                                    model: {
                                      value: _vm.DueDate,
                                      callback: function ($$v) {
                                        _vm.DueDate = $$v
                                      },
                                      expression: "DueDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          {
                            staticClass: "ml-0 mt-4 mb-4 mr-5 mr-5 form-group",
                          },
                          [
                            _c(
                              "b-col",
                              { attrs: { sm: "5" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t("mandate.cdtr_ref"),
                                    placeholderValue:
                                      _vm.$t("mandate.cdtr_ref"),
                                  },
                                  model: {
                                    value: _vm.CdtrRefCollection,
                                    callback: function ($$v) {
                                      _vm.CdtrRefCollection = $$v
                                    },
                                    expression: "CdtrRefCollection",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { sm: "5" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t("mandate.purpose"),
                                    placeholderValue: _vm.$t("mandate.purpose"),
                                  },
                                  model: {
                                    value: _vm.Purpose,
                                    callback: function ($$v) {
                                      _vm.Purpose = $$v
                                    },
                                    expression: "Purpose",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          {
                            staticClass: "ml-0 mt-4 mb-4 mr-5 mr-5 form-group",
                          },
                          [
                            _c(
                              "b-col",
                              { attrs: { sm: "5" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t(
                                      "mandate.purpose_category"
                                    ),
                                    placeholderValue: _vm.$t(
                                      "mandate.purpose_category"
                                    ),
                                  },
                                  model: {
                                    value: _vm.PurposeCategory,
                                    callback: function ($$v) {
                                      _vm.PurposeCategory = $$v
                                    },
                                    expression: "PurposeCategory",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { sm: "5" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t(
                                      "mandate.remittance_info"
                                    ),
                                    placeholderValue: _vm.$t(
                                      "mandate.remittance_info"
                                    ),
                                  },
                                  model: {
                                    value: _vm.RemittanceInfo,
                                    callback: function ($$v) {
                                      _vm.RemittanceInfo = $$v
                                    },
                                    expression: "RemittanceInfo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "form-group justify-content-end" },
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "2" } },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "btnFilter_2",
                                attrs: {
                                  variant: "primary",
                                  disabled: !_vm.isFormValid,
                                },
                                on: { click: _vm.sendTransaction },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-light fa-paper-plane",
                                  attrs: { size: "17px" },
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("mandate.send"))),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }